<template>
  <q-layout view="hHh lpR fFf">
    <q-header class="bg-white text-black">
      <q-toolbar style="padding:2px">
        <q-toolbar-title >
            <div class="row" style="">
                <q-btn class="col-*" size="md" color="primary" flat dense icon="menu" @click="showSummary = true; refreshData()" style="width:30px; margin:0; padding: 0;"/>
                <q-input class="col" autocorrect="off" autocapitalize="off" autocomplete="off" spellcheck="false" autofocus clearable dense outlined debounce="1000" :value="barcode" @input="v => scanItem(v)">
                    <template v-slot:append>
                    <q-icon name="document_scanner" />
                    </template>            
                </q-input>
            </div>
        </q-toolbar-title>
      </q-toolbar>
    </q-header>
    <q-page-container>
        <div v-if="firstLoad && scannedItems.length == 0" >
           <div style="width: 180px; margin:0 auto;">
                <img width="180" src="../assets/scan.jpg" />
            </div>     
            <p class="text-center" style="font-weight:bold; font-size: 35px;">Stock Take</p>
            <p class="text-center" style="font-weight:bold; font-size: 30px;">Scan First Item</p>
        </div>
        <div v-if="!item && firstLoad == false && !loading">
            <div style="width: 180px; margin:0 auto;">
                <img width="180" src="../assets/warning.jpg" />
            </div>  
            <p class="text-center" style="font-weight:bold; font-size: 35px;">BARCODE NOT FOUND</p>
        </div>
        <q-inner-loading :showing="loading">
            <q-spinner-gears size="100px" color="primary" />
        </q-inner-loading>

        <div style="padding: 0; margin: 0 5px;">
            <q-table 
                hide-header
                :hide-pagination="true"
                :rows-per-page-options="[0]"                
                :data="scannedItems" 
                :columns="columns" 
                row-key="skuId"
            >
                <template v-slot:body="props">
                    <q-tr :props="props" class="row" style="height:40px">
                        <q-td class="col-*" style="height:40px;padding: 0; margin: 0; width: 30px;">
                            <q-btn size="sm" flat dense @click="props.expand = !props.expand" :icon="props.expand ? 'expand_less' : 'expand_more'" style="width: 30px; height:40px;"/>
                        </q-td>
                        <q-td class="col scroll_content" style="height:40px;overflow:auto; width:0px;padding: 0; margin: 0" key="col1" >
                                <div class="row" style="font-size:18px; line-height: 24px;">{{props.row.name}}</div>
                                <div class="row" style="font-size:12px; line-height: 12px;">{{getSecondLine(props.row)}}</div>                                
                        </q-td>
                        <q-td class="col-*" key="col2" style="display: block; height:40px; width:40px; padding: 0; margin: 0 auto;" >
                            <div class="row" style="margin: 4px auto 0 auto; display: block; height:15px; width: 15px; border:1px solid silver; border-radius: 5px;" :style="`background-color:${props.row.colour.hex}`"></div>
                            <p class="text-center text-bold" style="font-family:monospace">{{props.row.count}}</p>
                        </q-td>
                    </q-tr>
                    <q-tr v-show="props.expand" :props="props">
                        <q-td auto-width v-if="props.row.itus">
                            <q-table 
                            dense
                            :hide-pagination="true"
                            :rows-per-page-options="[0]"                        
                            :columns="[{
                                    label: 'Barcode ID',
                                    field: 'barcode',
                                    name: 'barcode',
                                    required: false,
                                    align: 'center',
                                    sortable: true
                                },
                                {
                                    label: 'Status',
                                    field: 'status',
                                    name: 'status',
                                    required: false,
                                    align: 'center',
                                    sortable: true
                                },
                                {
                                    field: 'id',
                                    name: 'id',
                                    required: false,
                                    align: 'center',
                                    sortable: false
                                }                                          
                            ]" 
                            :data="props.row.itus" 
                            row-key="id" >
                                <template v-slot:header="props">
                                    <q-tr :props="props" class="row" style="margin:0; padding:0">
                                        <q-th class="col-*" style="width: 80px; padding: 5px 0; margin: 0;" key="barcode" :props="props">Barcode</q-th>
                                        <q-th class="col" style="margin:0;padding: 5px 0;" key="status" :props="props">Status</q-th>
                                        <q-th class="col-*" key="id" style="width: 30px; margin:0;padding:0" :props="props"></q-th>                                              
                                    </q-tr>
                                </template>                            
                                <template v-slot:body="props">
                                    <q-tr :props="props" class="row" style="overflow: hidden; margin:0; padding:0">
                                        <q-td dense class="col-*" style="font-family: monospace;width: 80px; padding: 4px 0; display: block;" key="barcode" :props="props">{{props.row.barcode}}</q-td>
                                        <q-td class="col scroll_content" key="status" :props="props" style="overflow: auto; width: 0px ; padding: 4px 0; margin:0;">{{props.row.status}}</q-td>
                                        <q-td class="col-*" style="width: 30px; margin:0;padding:0" key="id" :props="props">
                                            <q-btn size="sm" flat color="primary" icon="clear" @click="removeScannedItem(props.row)" style="width:30px;margin:0;padding:0"/>
                                        </q-td>
                                    </q-tr>                            
                                </template>                        
                            </q-table>
                        </q-td>                    
                    </q-tr>
                </template>
            </q-table>
        </div>

    <!-- Summary popup -->
    <q-dialog v-model="showSummary" full-width full-height>
        <q-card>
        <q-layout view="hHh lpR fff" container style="height: 100%" class="bg-white text-black">
            <q-header class="bg-white text-black">
            <q-toolbar>
                <q-toolbar-title>
                    <q-tabs
                    v-model="tab"
                    dense
                    class="text-grey"
                    active-color="primary"
                    indicator-color="primary"
                    align="justify"
                    >
            <q-tab name="menu" label="Menu" />
            <q-tab name="report" label="Report" />
            </q-tabs>
                </q-toolbar-title>
            </q-toolbar>
            </q-header>
            <q-page-container>
                <q-tab-panels v-model="tab" animated >
                    <q-tab-panel name="menu">
                        <q-card class="my-card">
                            <q-card-section>
                                <div class="text-bold" style="margin:0 0 10px 0">Save as</div>
                                <div></div>
                                <q-input v-model="stocktakeName" type="text" dense outlined/>
                            </q-card-section>
                            <q-card-actions align="right" style="margin:-12px 10px 0 0;padding:">
                                <q-btn color="primary" dense label="Rename" @click="renameStocktake()" />
                            </q-card-actions>                            
                        </q-card>
                        <br>
                        <q-card class="my-card">
                            <q-card-section>
                                <div class="text-bold" style="margin:0 0 10px 0">Complete Stocktake</div>
                                <div>This action will mark the stocktake as completed.</div>
                            </q-card-section>
                            <q-card-actions align="center" style="margin:-12px 0 0 0;padding:">
                                <q-btn color="primary" dense label="Complete Stocktake" @click="completeStocktake()" />
                            </q-card-actions>                            
                        </q-card>
                        <br>                      
                        <q-card class="my-card">
                            <q-card-section>
                                <div class="text-bold" style="margin:0 0 10px 0">New Stocktake</div>
                                <div>Creates a new stocktake.</div>
                            </q-card-section>
                            <q-card-actions align="center" style="margin:-12px 0 0 0;padding:">
                                <q-btn color="primary" dense label="New" @click="createStk_mutation()" />
                            </q-card-actions>                            
                        </q-card>                       
                    </q-tab-panel>
                    <q-tab-panel name="report">
                        <template v-for="(stk,index) in stocktakes">
                            <q-card v-bind:key="index" class="my-card" style="margin: 10px 0">
                                <q-card-section>
                                    <div class="row"><b>{{stk.name}}</b></div>
                                    <div class="row">Items: {{stk.items.length}}</div>
                                    <div class="row"></div>Status: {{stk.status}}
                                    <div class="row"></div>Active: {{(stk.active)?"Yes" : "No"}}
                                    <div class="row"></div>Updated: {{moment(stk.updatedAt).format('LLLL')}}
                                </q-card-section>
                                <q-card-actions align="right" style="margin:-12px 10px 0 0;padding:">
                                    <q-btn dense color="primary" label="Export" @click="singleExportToCSV(stk)"/>
                                    <q-btn dense color="primary" icon="print" label="Print"/>
                                    <q-btn dense outline flat color="primary" icon="delete" />
                                </q-card-actions>                            
                            </q-card>
                        </template>


<!-- 
                        <q-card class="my-card">

                            <q-card-section>
                                <div class="text-bold" style="margin:0 0 10px 0">Print Report</div>
                                <div>Print the stocktake report to view all differences in current stock levels and missing items</div>
                            </q-card-section>
                            <q-card-actions align="right" style="margin:-12px 10px 0 0;padding:">
                                <q-btn color="primary" icon="print" label="Print"/>                            
                            </q-card-actions>                            
                        </q-card> -->
                    </q-tab-panel>
                </q-tab-panels>
            </q-page-container>

        </q-layout>

        </q-card>    

    </q-dialog>    

    </q-page-container>

    <q-footer class="bg-white">
      <q-toolbar style="min-height:0">
        <q-toolbar-title  >
            <div style="padding: 0; margin: 0; font-size: 8px; border:1px dotted black; color:black">Ready!</div>
        </q-toolbar-title>
      </q-toolbar>
    </q-footer>

  </q-layout>
</template>

<script>
import gql from 'graphql-tag'
import moment from 'moment'
import saveAs from 'file-saver'

export default {
  name: 'scan_stocktake',
  data(){
    return {
      moment,
      stocktake:{name:"Default_name"
      },
      stocktakes:{},
      tab:'menu',
      showSummary:false,
      barcode:"",
      item: false,
      autofocus: true,
      disable: false,
      loading: false,
      firstLoad: true,
      stocktakeId: "",
      stocktakeName:"",
      stocktakeStatus:"",
      stocktakeActive:"",
      stocktakeLastUpdate:"",
      scannedItems: [],
      innerCols:[
            {
            label: 'BC',
            field: 'id',
            name: 'barcode',
            required: false,
            align: 'center',
            sortable: false
        },
      ],
      columns: [
        {
            name: 'action',
            required: false,
            align: 'center',
            sortable: false
        },        
        {
            name: 'firstCol',
            required: false,
            align: 'left',
            sortable: false
        },
        {
            name: 'secondCol',
            required: false,
            align: 'left',
        }
]
    }   
  },
  async mounted(){
    await this.lastStocktake_query()
  },
  methods:{
    async singleExportToCSV(stocktake){
        let csvContent = [];
        let name = '"Stocktake Name",'+stocktake.name+',,,,,,,,,,,,,,,,,,'+"\n"
        let headers = '"barcode","name","ituId","ProductId","status","type","manufacturer","brand","colour.name","colour.group","colour.superGroup","material","size","range","holds","skuId","retailPrice","stockPrice","containerPrice"'+"\n"
        csvContent.push(name);
        csvContent.push(headers);     
        for(let item of stocktake.items){
            let retailPrice = "";
            let containerPrice = "";
            let stockPrice = "";
            
            let prod = await this.getProduct_query(item.skuId);
            for(let sku of prod.skus){
                if(sku.id == item.skuId){
                    retailPrice = sku.retailPrice;
                    containerPrice = sku.containerPrice;
                    stockPrice = sku.price;
                }
            }
            
            for(let itu of item.itus){
              let line = '"'+itu.barcode+'","'+item.name+'","'+itu.id+'","'+prod.id+'","'+itu.status+'","'+itu.type+'","'+item.manufacturer+'","'+item.brand+'","'+item.colour.name+'","'+item.colour.group+'","'+item.colour.superGroup+'","'+item.material+'","'+item.size+'","'+item.range+'","'+item.holds+'","'+item.skuId+'","'+retailPrice+'","'+stockPrice+'","'+containerPrice+'"';
              csvContent.push(line+"\n")
            }
        }
        saveAs(new Blob([csvContent], { type: 'application/octet-stream' }), `STOCKTAKE_${stocktake.name}.csv`)
    },
    async refreshData(){
        await this.stocktakes_query();
    },
    async removeScannedItem(item){
        let sku_index;
        let itu_index;
        for(let i in this.scannedItems){
            let sku = this.scannedItems[i];
            if(sku.skuId == item.skuId){
                sku_index = i;
                for(let j in sku.itus){
                    let itu = sku.itus[j]
                    if(itu.id == item.id){
                        this.scannedItems[i].itus.splice(j,1);
                    }
                }
            }
        
        }

        if(this.scannedItems[sku_index].itus.length == 0){
            this.scannedItems.splice(sku_index,1);
        }
        await this.updateStocktake_mutation(this.stocktakeId,{items:this.scannedItems});
    },    
    getSecondLine(item){
        let line = ""
        if(item.brand) line = line + item.brand + " | ";
        if(item.range) line = line + item.range + " | ";        
        if(item.manufacturer) line = line + item.manufacturer + " | ";
        if(item.material) line = line + item.material + " | ";
        if(item.size) line = line + item.size + " | ";
        if(item.holds) line = line + "Holds: " + item.holds + " | ";
        if(item.type) line = line + item.type;        
        return line
    },    
    async scanItem(barcode){
        this.item = await this.ituBarcode_query(barcode);
        let itu = {
            id: this.item.id,
            barcode: this.item.barcode,
            type: this.item.type,
            status: this.item.status,
            skuIndex: this.item.skuIndex,
            index: this.item.index,
            skuId: this.item.sku.id,
        };

        let updateDatabase = false;

        if(this.item){
            //1st look for existing SKU
            let foundSku = false;
            let currentPosition;
            for(let i in this.scannedItems){
                let skuOnList = this.scannedItems[i];
                if(this.item.sku.id == skuOnList.skuId){
                    foundSku = true;
                    let foundItu = false;
                    for(let j in skuOnList.itus){
                        let ituOnList = skuOnList.itus[j]
                        if(ituOnList.id == this.item.id){
                            foundItu = true;                     
                        }
                    }
                    // ITU NOT FOUND, ADD IT THIS SKU
                    if(!foundItu){
                        currentPosition =  i;
                        this.scannedItems[i].itus.unshift(itu);
                        this.scannedItems[i].count++
                        // updateDatabase = true;
                    }
                }   
            }
            //SKU NOT FOUND, ADD IT TO ARRAY
            if(!foundSku){
                this.scannedItems.unshift({
                    productId: this.item.product.id,
                    skuId: this.item.sku.id,
                    name: this.item.product.name,
                    colour: this.item.sku.options.colour,
                    brand: this.item.product.attributes.brand,
                    manufacturer: this.item.product.attributes.manufacturer,
                    holds: this.item.product.attributes.holds,
                    range: this.item.product.attributes.range,
                    type: this.item.product.attributes.type,
                    material: this.item.product.attributes.material,
                    grip: this.item.product.attributes.grip,
                    size: this.item.product.attributes.size,
                    count: 1,
                    itus:[itu]
                })
                await this.updateStocktake_mutation(this.stocktakeId,{items:this.scannedItems});
            }else if(foundSku && currentPosition){
                //Moved to the top of first position of the array
                let itemToMove = this.scannedItems.splice(currentPosition,1)
                this.scannedItems.unshift(itemToMove[0])
                await this.updateStocktake_mutation(this.stocktakeId,{items:this.scannedItems});  
                // this.scannedItems.unshift(itemToMove);
            }
        }
    },
    async warningVibrate(){
        let x = navigator.vibrate([10,200,200,100,200])
        // var snd = new Audio("data:audio/mp3;base64,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");  
        var snd = new Audio("data:audio/wav;base64,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");  
        snd.play();        
        return true
    },
    async ituBarcode_query(barcode){
        let x = navigator.vibrate(300)
        var snd = new Audio("data:audio/wav;base64,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");  
        snd.play();
        this.barcode = null
        this.loading = true
        try{  
            let response = await this.$apollo.query({
            query: gql`
                query ituByBarcode($barcode: String!) {
                ituByBarcode(barcode: $barcode){
                    id
                    barcode
                    paidPrice
                    type
                    status
                    weight
                    skuIndex
                    index
                    sku{

                        id
                        options
                    }
                    product{
                        id
                        name
                        reference
                        attributes
                        images {
                          url
                        }
                    }
                    createdAt
                    updatedAt
                }
                }
            `,
            variables: {
                barcode: barcode
            },
            fetchPolicy: 'network-only',
            })
            this.barcode = ''
            this.loading = false;            
            this.firstLoad = false;
            return response.data.ituByBarcode;                       
        }catch(e){
            this.barcode = ''
            this.loading = false
            this.firstLoad = false;
            return false;
        }
    },
    async renameStocktake(){
        return await this.updateStocktake_mutation(this.stocktakeId,{name:this.stocktakeName});
    },
    async completeStocktake(){
        await this.updateStocktake_mutation(this.stocktakeId,{status:"completed",active:false});
        await this.createStk_mutation();
    },
async createStk_mutation (){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation createStocktake{
              createStocktake{
                id
                name
                items
                status
                active
              }
            }
          `,
        })

        let newStocktake = response.data.createStocktake;
        this.stocktakeId = newStocktake.id;
        this.stocktakeName = newStocktake.name;
        this.scannedItems = newStocktake.items;
        this.stocktakeLastUpdate =  newStocktake.updatedAt;
        this.stocktakeStatus = newStocktake.status;
        this.stocktakeActive = newStocktake.active;
        this.showSummary = false;

    },
    async lastStocktake_query (){
        let response = await this.$apollo.query({
          query: gql`
            query lastStocktake{
              lastStocktake{
                id
                name
                items
                status
                active
                updatedAt
              }
            }
          `,
        })
        let stocktake = response.data.lastStocktake;
        this.stocktakeId = stocktake.id;
        this.stocktakeName = stocktake.name;
        this.scannedItems = stocktake.items;
        this.stocktakeLastUpdate =  stocktake.updatedAt;
        this.stocktakeStatus = stocktake.status;
        this.stocktakeActive = stocktake.active;       
    },
    async stocktakes_query (){
        let response = await this.$apollo.query({
          query: gql`
            query stocktakes{
              stocktakes{
                id
                name
                items
                status
                active
                updatedAt
              }
            }
          `,
           fetchPolicy: 'network-only'
        })
        this.stocktakes = Object.assign({},response.data.stocktakes);
    },    
    async updateStocktake_mutation (id,input){
        let response = await this.$apollo.mutate({
          mutation: gql`
            mutation updateStocktake($id:ID!,$input:StocktakeInput){
              updateStocktake(id:$id,input:$input){
                id
                name
                items
                status
                active
              }
            }
          `,
            variables: {
                id,
                input
            },          
        })
        this.updateStocktake_response = response.data.updateStocktake
    },
    async getProduct_query(skuId){
        console.log('skuId',skuId);
        
        let response = await this.$apollo.query({
            query: gql`query productBySkuId ($skuId: ID!) {
                productBySkuId (skuId: $skuId) {
                    id
                    name
                    description
                    reference
                    images {
                        url
                        name
                    }
                    attributes
                    urlSlug
                    skus {
                        id
                        attributes
                        barcode
                        options
                        price
                        containerPrice
                        retailPrice
                        showInContainer
                        showInRetail
                        hideInStock
                        showPreStock
                        preStock
                        availableOn
                        stock
                        colour
                        deleted
                        itus{
                            id
                            barcode
                            paidPrice
                            type
                            status
                            weight
                            createdAt
                            updatedAt
                        }
                    }
                }
            }
            `,
            variables: {
                skuId:skuId
            },
            fetchPolicy: 'network-only'
        })
        return response.data.productBySkuId;
    }
  }
}
</script>

<style lang="stylus" scoped>
.scroll_content::-webkit-scrollbar {
    display: none;
}
.scroll_content{
    padding: 0 5px;
}

</style>